import eventTimer from '../helper/eventTimer';
import { useEffect, useState } from 'react';
import { useBaseParam } from './useBaseParam';
import { fetchLoanBanner } from '../../infra/api/fetchLoanBanner';
import { MEDIA_CODE, PLACEMENT_TYPE } from '../types/types';
import { BANNER } from '../staticData/bannerList';
import useNav from './useNav';

export const useBanner = (
  media: string,
  placementType: PLACEMENT_TYPE,
  serverTime?: string,
) => {
  const [bannerList, setBannerList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { navigateByLinkType } = useNav();

  const getBanner = useBaseParam(fetchLoanBanner, {
    mediaCd: MEDIA_CODE[media],
    placementType,
  });

  // deprecated
  const getStaticBanner = (
    seq: string | number,
    media: string,
    currentTime: string,
  ) => {
    const banner = BANNER[seq][media];
    if (eventTimer(banner?.start, banner?.end, currentTime)) {
      return [banner.banner];
    }
    return [];
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getBanner();
      if (res?.data?.isSucceed === true) {
        const banner1 = res?.data?.result?.bannerList || [];

        // deprecated
        const banner2 = getStaticBanner('2', media || '', serverTime || '');

        setBannerList([...banner1, ...banner2]);
      }
      setIsLoading(false);
    })();
  }, []);

  return {
    isLoading,
    bannerList: bannerList.map((item: any) => ({
      ...item,
      navigate: () =>
        navigateByLinkType(item.landingType, item.landingDestination),
    })),
    hasBannerList: bannerList.length > 0,
  };
};
